'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var HeaderAndContentLayout = styled__default.section(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  & > *:first-child {\n    position: sticky;\n    top: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  & > *:first-child {\n    position: sticky;\n    top: 0;\n  }\n"])));
var templateObject_1;

var TwoColumnLayout = styled__default.section(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 5fr 2fr;\n  width: 100%;\n"], ["\n  display: grid;\n  grid-template-columns: 5fr 2fr;\n  width: 100%;\n"])));
var templateObject_1$1;

exports.HeaderAndContentLayout = HeaderAndContentLayout;
exports.TwoColumnLayout = TwoColumnLayout;
